class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    const mq = window.matchMedia('(min-width: 990px)');

    // handlers stockés pour pouvoir les retirer/rajouter selon la taille écran
    this._cartLinkClickHandler =
      this._cartLinkClickHandler ||
      ((event) => {
        event.preventDefault();
        this.open(cartLink);
      });

    this._cartLinkKeydownHandler =
      this._cartLinkKeydownHandler ||
      ((event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });

    const enableDrawerBehavior = () => {
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', this._cartLinkClickHandler);
      cartLink.addEventListener('keydown', this._cartLinkKeydownHandler);
    };

    const disableDrawerBehavior = () => {
      cartLink.removeAttribute('role');
      cartLink.removeAttribute('aria-haspopup');
      cartLink.removeEventListener('click', this._cartLinkClickHandler);
      cartLink.removeEventListener('keydown', this._cartLinkKeydownHandler);
    };

    const apply = () => {
      if (mq.matches) {
        // Desktop: on laisse le lien fonctionner => va sur /cart
        disableDrawerBehavior();
      } else {
        // Mobile: drawer
        enableDrawerBehavior();
      }
    };

    apply();
    // met à jour si on redimensionne la fenêtre
    if (mq.addEventListener) mq.addEventListener('change', apply);
    else mq.addListener(apply);
  }

    closeOpenMenuDrawer() {
      const headerDrawer = document.querySelector('header-drawer');
      if (!headerDrawer) return;

      const openMenuDetails = headerDrawer.querySelector('#Details-menu-drawer-container[open]');
      if (!openMenuDetails) return;

      const summaryElement =
        openMenuDetails.querySelector(':scope > summary') ||
        headerDrawer.querySelector('summary');

      if (!summaryElement) return;

      if (typeof headerDrawer.closeMenuDrawer === 'function') {
        headerDrawer.closeMenuDrawer(new Event('click'), summaryElement);
        return;
      }

      openMenuDetails.classList.remove('menu-opening');
      openMenuDetails.removeAttribute('open');
      summaryElement.setAttribute('aria-expanded', 'false');

      document.documentElement.classList.remove('menu-drawer-ui-open');
      document.body.classList.remove('menu-drawer-ui-open');
      document.body.classList.remove('overflow-hidden-tablet', 'overflow-hidden-desktop');
    }


  open(triggeredBy) {
    window.clearTimeout(this._cartOverflowUnlockTimer);

    this.closeOpenMenuDrawer();

    if (typeof window.setDrawerUiOpen === 'function') {
      window.setDrawerUiOpen(true);
    }

    if (triggeredBy) this.setActiveElement(triggeredBy);

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    setTimeout(() => {
      if (typeof window.updateDrawerOffsets === 'function') {
        window.updateDrawerOffsets();
      }

      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');

        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');

    requestAnimationFrame(() => {
      if (typeof window.updateDrawerOffsets === 'function') {
        window.updateDrawerOffsets();
      }
    });
  }

  close() {
    window.clearTimeout(this._cartOverflowUnlockTimer);

    this.classList.remove('active');
    removeTrapFocus(this.activeElement);

    if (typeof window.setDrawerUiOpen === 'function') {
      window.setDrawerUiOpen(false);
    }

    this._cartOverflowUnlockTimer = window.setTimeout(() => {
      if (!this.classList.contains('active')) {
        document.body.classList.remove('overflow-hidden');
      }
    }, 460);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
